<template>
  <div>
    <div class="cabinet-console-container">
      <!--Menu-->
      <ConsoleMenuMobile :expanded="expandedMobile" @expand="expandedMobile = !expandedMobile"></ConsoleMenuMobile>
      <ConsoleMenu :expanded="expanded" @expand="expanded = !expanded"></ConsoleMenu>

      <!-- Header - Main account summary -->
      <ConsoleHeader></ConsoleHeader>

      <!-- Page content -->
      <div class="content" :class="{ 'cabinet-console-content-collapsed': !expanded }">
        <ConsoleContent></ConsoleContent>
      </div>
    </div>

    <!-- <Footer class="register-page__footer"></Footer> -->

    <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="login-modal">
      <template #header>
        <h3>Login</h3>
      </template>
      <template #body>
        <p>{{ dialogMessage }}</p>
      </template>
      <template #footer>
        <button @click="showDialog = false">{{ $t("register.ok") }}</button>
      </template>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
// import CabinetAPI from '../../app/cabinet-api';

import ConsoleMenu from "@/components/cabinet/ConsoleMenu";
import ConsoleMenuMobile from "@/components/cabinet/ConsoleMenuMobile";
import ConsoleHeader from "@/components/cabinet/ConsoleHeader";
import ConsoleContent from "@/components/cabinet/ConsoleContent";
import Modal from "../../components/Modal";
import Preloader from '../../components/Preloader.vue';
import { getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/runtime-core"
import Footer from "@/components/login/Footer";

export default {
  name: "Console",
  components: {
    ConsoleHeader,
    ConsoleContent,
    ConsoleMenuMobile,
    ConsoleMenu,
    Modal,
    Preloader,
    Footer
  },
  setup() {
    let showDialog = ref(false)
    let secure3dDialog = ref(false)

    let currency = ref(null)
    let amount = ref(null)
    let lastdigits = ref(null)

    let dialogMessage = ref(null)
    let secure3durl = ref(null)
    let results = ref(null)

    let expanded = ref(true)
    let expandedMobile = ref(false)
    let themeLight = ref(true)
    let pingTest = ref(null)
    let showPaymentResult = ref(false)


    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    onMounted(() => {
      emitter.on('showDialog', (message) => {
        dialogMessage.value = message
        showDialog.value = true
      })
    })

    onUnmounted(() => {
      emitter.off('showDialog')
      emitter.off('secure3dDialog')
    })
    
    return {
      dialogMessage,
      secure3durl,
      results,
      showDialog,
      secure3dDialog,
      currency,
      amount,
      lastdigits,
      showPaymentResult,
      expandedMobile,
      expanded,
      themeLight,
      pingTest
    }
  },
}
</script>